import React from "react";
import { Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";

const PaymentFailedModal = (props) => {
  const history = useHistory();

  const backtohome = () => {
    history.push(`/dashboard/`);
    props.setShowFailedModal(false);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="py-3 pb-5">
        <Modal.Body>
          <div className="flex justify-center items-center w-full">
            <div className="mb-5">
              <Icon
                icon="ooui:error"
                style={{ fontSize: "6em", color: "red" }}
              />
            </div>
          </div>

          <h4 className="text-center">Payment Failed!</h4>
          <p className="text-center mt-2">
            Your payment has been failed. Please click CONTINUE and try again
          </p>
        </Modal.Body>

        <div className="flex items-center justify-center">
          <button
            onClick={backtohome}
            className="bg-[#fc2e03] py-[6px] px-4 text-white text-base font-medium"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentFailedModal;
